module.exports = "<div class=\"w-100 p-0 m-0\">\r\n    <img [src]=\"s_UrlImagen\" [alt]=\"s_UrlImagen\" class=\"img-fluid\" sizes=\"100vw\">\r\n</div>"